import { render } from "./Base.vue?vue&type=template&id=68fadf4d&bindings={\"beaconUserObject\":\"options\",\"identify\":\"options\"}"
import script from "./Base.vue?vue&type=script&lang=js"
export * from "./Base.vue?vue&type=script&lang=js"
script.render = render

export default script